import { createContext, ReactNode, useContext } from "react";

import { useFilterPackageActivity } from "./filter-package-activity.hook";

const FilterPackageActivityContext = createContext(
  {} as ReturnType<typeof useFilterPackageActivity>
);
export function useFilterPackageActivityContext() {
  return useContext(FilterPackageActivityContext);
}

interface FilterPackageActivityProviderProps {
  children: ReactNode;
}
export function FilterPackageActivityProvider({
  children,
}: FilterPackageActivityProviderProps) {
  return (
    <FilterPackageActivityContext.Provider value={useFilterPackageActivity()}>
      {children}
    </FilterPackageActivityContext.Provider>
  );
}